import { useState } from 'react';
import { NumericFormat } from 'react-number-format';
import Select from 'react-select';
import Drawer from '~/components/Drawer';
import {
    inputStyles,
    labelStyles,
    requiredStyles,
    sectionStyles,
} from './styles';
import { FaPlus } from 'react-icons/fa6';
import { RiDeleteBinLine } from 'react-icons/ri';

interface Props {
    isOpen: boolean;
    setIsOpen: any;
}

const AddVendorDrawer: React.FC<Props> = ({ isOpen, setIsOpen }) => {
    return (
        <Drawer
            isOpen={isOpen}
            setIsOpen={setIsOpen}
            title={'Add Vendor or Organization'}
        >
            <h2 className={sectionStyles}>CONTACTS</h2>

            <form>
                <label htmlFor='cid-vendor-name' className={labelStyles}>
                    Vendor or Organization Name
                    <span className={requiredStyles}>*</span>
                </label>
                <input
                    id='cid-vendor-name'
                    className={`${inputStyles} w-full`}
                />

                <div className='mt-5 rounded bg-gray p-4'>
                    <h2 className='font-bold'>Contact</h2>

                    <label htmlFor='cid-first-name' className={labelStyles}>
                        First Name<span className={requiredStyles}>*</span>
                    </label>
                    <input
                        id='cid-first-name'
                        className={`${inputStyles} w-full`}
                    />

                    <label htmlFor='cid-last-name' className={labelStyles}>
                        Last Name<span className={requiredStyles}>*</span>
                    </label>
                    <input
                        id='cid-last-name'
                        className={`${inputStyles} w-full`}
                    />

                    <label htmlFor='cid-role' className={labelStyles}>
                        Role
                    </label>
                    <input id='cid-role' className={`${inputStyles} w-full`} />

                    <label htmlFor='cid-email' className={labelStyles}>
                        Email<span className={requiredStyles}>*</span>
                    </label>
                    <input id='cid-email' className={`${inputStyles} w-full`} />

                    <div className='flex items-center gap-[8px]'>
                        <div className='w-1/2'>
                            <label className={`w-full ${labelStyles}`}>
                                Contact Number
                                <span className={requiredStyles}>*</span>
                            </label>
                            <input className={`${inputStyles} w-full`} />
                        </div>

                        <div>
                            <label className={`w-full ${labelStyles}`}>
                                Type<span className={requiredStyles}>*</span>
                            </label>
                            <select className={`${inputStyles} w-full`}>
                                <option value=''>Select</option>
                                <option value='Cell'>Cell</option>
                                <option value='Direct'>Direct</option>
                                <option value='Fax'>Fax</option>
                                <option value='Home'>Home</option>
                                <option value='Main'>Main</option>
                                <option value='Office'>Office</option>
                                <option value='Pager'>Pager</option>
                            </select>
                        </div>

                        <div className='self-end'>
                            <button>
                                <RiDeleteBinLine
                                    className='text-red'
                                    size={20}
                                />
                            </button>
                        </div>
                    </div>

                    <button className='mt-[16px] flex items-center gap-[8px] text-[14px]/[18px] font-bold text-[#00AEB3]'>
                        <FaPlus />
                        ADD PHONE NUMBER
                    </button>
                </div>

                <button className='mt-[16px] flex items-center gap-[8px] text-[14px]/[18px] font-bold text-[#00AEB3]'>
                    <FaPlus />
                    ADD CONTACT
                </button>

                <h2 className={sectionStyles}>ADDRESS</h2>

                <label htmlFor='cid-address-1' className={labelStyles}>
                    Street Address 1<span className={requiredStyles}>*</span>
                </label>
                <input id='cid-address-1' className={`${inputStyles} w-full`} />

                <label htmlFor='cid-address-2' className={labelStyles}>
                    Street Address 2
                </label>
                <input id='cid-address-2' className={`${inputStyles} w-full`} />

                <div className='flex items-center gap-[8px]'>
                    <div className='w-1/2'>
                        <label
                            htmlFor='cid-city'
                            className={`w-full ${labelStyles}`}
                        >
                            City<span className={requiredStyles}>*</span>
                        </label>
                        <input
                            id='cid-city'
                            className={`${inputStyles} w-full`}
                        />
                    </div>

                    <div className='w-1/4'>
                        <label
                            htmlFor='cid-state'
                            className={`w-full ${labelStyles}`}
                        >
                            State<span className={requiredStyles}>*</span>
                        </label>
                        <Select id='cid-state' menuPlacement='auto' />
                    </div>

                    <div className='w-1/4'>
                        <label
                            htmlFor='cid-zip-code'
                            className={`w-full ${labelStyles}`}
                        >
                            Zip Code<span className={requiredStyles}>*</span>
                        </label>
                        <input
                            id='cid-zip-code'
                            className={`${inputStyles} w-full`}
                        />
                    </div>
                </div>

                <h2 className={sectionStyles}>VENDOR INFORMATION</h2>

                <label
                    htmlFor='cid-npi-number'
                    className={`w-full ${labelStyles}`}
                >
                    NPI Number
                </label>
                <input
                    id='cid-npi-number'
                    className={`${inputStyles} w-full`}
                />

                <label
                    htmlFor='cid-business-type'
                    className={`w-full ${labelStyles}`}
                >
                    Business Type<span className={requiredStyles}>*</span>
                </label>
                <Select
                    id='cid-business-type'
                    className='w-full'
                    menuPlacement='auto'
                />

                <label
                    htmlFor='cid-support-population'
                    className={`w-full ${labelStyles}`}
                >
                    Support Population<span className={requiredStyles}>*</span>
                </label>
                <Select
                    id='cid-support-population'
                    className='w-full'
                    menuPlacement='auto'
                />

                <label htmlFor='cid-type' className={`w-full ${labelStyles}`}>
                    Type
                </label>
                <Select id='cid-type' className='w-full' menuPlacement='auto' />
            </form>

            <div className='mb-[30px] flex gap-[16px]'>
                <button
                    className='mt-[30px] grow rounded-full border-[2px] px-[24px] py-[7px] text-[14px]/[18px] font-bold uppercase transition-colors duration-500 hover:border-black hover:bg-black hover:text-white'
                    onClick={() => setIsOpen(false)}
                >
                    Cancel
                </button>
                <button className='mt-[30px] grow rounded-full border-[2px] border-warning bg-warning px-[24px] py-[7px] text-[14px]/[18px] font-bold uppercase transition-colors duration-500 hover:border-[#E6F7F8] hover:bg-[#E6F7F8]'>
                    Save
                </button>
            </div>
        </Drawer>
    );
};

export default AddVendorDrawer;
